module.exports = __webpack_public_path__ + "static/media/15.28b0719b.jpg";